// src/pages/.../ManageMembers/data/manageMembers.data.js

export const PLAN_CONFIG_BY_ROLE = {
  7: {
    label: "Présence Free",
    limit: 50,
    badgeClass:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  },

  3: {
    label: "Présence",
    limit: 100,
    badgeClass:
      "bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300",
  },

  4: {
    label: "Présence Pro",
    limit: 200,
    badgeClass:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",
  },

  5: {
    label: "Présence Ultim",
    limit: Infinity,
    badgeClass:
      "bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
  },
};

export const DEFAULT_PLAN_CONFIG = {
  label: null,
  limit: Infinity,
  badgeClass:
    "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export const GROUP_COLOR_MAP = {
  "bg-indigo-400": "bg-indigo-400 text-white",
  "bg-indigo-500": "bg-indigo-500 text-white",

  "bg-purple-400": "bg-purple-400 text-white",
  "bg-purple-500": "bg-purple-500 text-white",

  "bg-green-400": "bg-green-400 text-white",
  "bg-green-500": "bg-green-500 text-white",

  "bg-yellow-400": "bg-yellow-400 text-slate-900",
  "bg-yellow-500": "bg-yellow-500 text-slate-900",

  "bg-blue-400": "bg-blue-400 text-white",
  "bg-blue-500": "bg-blue-500 text-white",

  "bg-red-400": "bg-red-400 text-white",
  "bg-red-500": "bg-red-500 text-white",

  "bg-pink-400": "bg-pink-400 text-white",
  "bg-pink-500": "bg-pink-500 text-white",

  "bg-gray-400": "bg-gray-400 text-white",
  "bg-gray-500": "bg-gray-500 text-white",

  "bg-cyan-400": "bg-cyan-400 text-slate-900",
  "bg-cyan-500": "bg-cyan-500 text-white",

  "bg-orange-400": "bg-orange-400 text-white",
  "bg-orange-500": "bg-orange-500 text-white",
};

export function getPlanConfig(roleId) {
  return PLAN_CONFIG_BY_ROLE[Number(roleId)] || DEFAULT_PLAN_CONFIG;
}